import { List, Map } from 'immutable';

import { getInventoryOperationValue } from '../../../product/getOperationValue';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../../../constants/channels';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';

export function quantity({ channel, preview }) {
  const payload = [];

  switch (channel) {
    case EBAY: {
      payload.push(
        Map({
          type: preview.getIn([ATTRIBUTE.QUANTITY, 'operation']),
          value: preview.getIn([ATTRIBUTE.QUANTITY, VALUE]),
        })
      );

      break;
    }

    case ETSY: {
      payload.push(
        Map({
          type: preview.getIn([ATTRIBUTE.QUANTITY, 'operation']),
          value: List([
            Map({
              combination: null,
              offeringId: null,
              value: preview.getIn([ATTRIBUTE.QUANTITY, VALUE]),
            }),
          ]),
        })
      );

      break;
    }

    case FAIRE: {
      if (preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.CONTINUE_SELLING])) {
        payload.push(
          Map({
            type: OPERATIONS[FAIRE].CONTINUE_SELLING.SET,
            value: !!preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.CONTINUE_SELLING]),
          })
        );
      }

      if (preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.RESTOCK_DATE])) {
        payload.push(
          Map({
            type: OPERATIONS[FAIRE].RESTOCK_DATE.SET,
            value: getInventoryOperationValue({
              channel: FAIRE,
              type: ATTRIBUTE.RESTOCK_DATE,
              value: preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.RESTOCK_DATE]),
            }),
          })
        );
      }

      if (preview.hasIn([ATTRIBUTE.QUANTITY, 'operation'])) {
        payload.push(
          Map({
            type: preview.getIn([ATTRIBUTE.QUANTITY, 'operation']),
            value: preview.getIn([ATTRIBUTE.QUANTITY, VALUE]),
          })
        );
      }

      break;
    }

    case SHOPIFY: {
      if (preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.CONTINUE_SELLING])) {
        payload.push(
          Map({
            type: OPERATIONS[SHOPIFY].CONTINUE_SELLING.SET,
            value: List([
              Map({
                combination: null,
                offeringId: null,
                value: Map({
                  inventoryPolicy: preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.CONTINUE_SELLING])
                    ? 'continue'
                    : 'deny',
                }),
              }),
            ]),
          })
        );
      }

      if (preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY])) {
        payload.push(
          Map({
            type: OPERATIONS[SHOPIFY].TRACK_QUANTITY.SET,
            value: List([
              Map({
                combination: null,
                offeringId: null,
                value: Map({
                  inventoryManagement: preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY])
                    ? SHOPIFY
                    : null,
                }),
              }),
            ]),
          })
        );
      }

      if (
        preview.hasIn([ATTRIBUTE.QUANTITY, 'operation']) && (
          !preview.hasIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY]) ||
          preview.getIn([ATTRIBUTE.QUANTITY, ATTRIBUTE.TRACK_QUANTITY])
        )
      ) {
        payload.push(
          Map({
            type: preview.getIn([ATTRIBUTE.QUANTITY, 'operation']),
            value: List([
              Map({
                combination: null,
                offeringId: null,
                value: preview.getIn([ATTRIBUTE.QUANTITY, VALUE]),
              }),
            ]),
          })
        );
      }

      break;
    }

    default: {
      break;
    }
  }

  return { payload };
}
